var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVisual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 103,
    viewBox: "0 0 104 103",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0006 19.3125C30.334 19.3125 11.8307 32.6596 4.33398 51.5C11.8307 70.3404 30.334 83.6875 52.0006 83.6875C73.6673 83.6875 92.1706 70.3404 99.6673 51.5C92.1706 32.6596 73.6673 19.3125 52.0006 19.3125ZM52.0006 72.9583C40.0406 72.9583 30.334 63.345 30.334 51.5C30.334 39.655 40.0406 30.0417 52.0006 30.0417C63.9606 30.0417 73.6673 39.655 73.6673 51.5C73.6673 63.345 63.9606 72.9583 52.0006 72.9583ZM52.0006 38.625C44.8073 38.625 39.0006 44.3758 39.0006 51.5C39.0006 58.6242 44.8073 64.375 52.0006 64.375C59.194 64.375 65.0006 58.6242 65.0006 51.5C65.0006 44.3758 59.194 38.625 52.0006 38.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisual);
export default __webpack_public_path__ + "static/media/iconVisual.9cf0f016fb5b7619da1ed99a324b4702.svg";
export { ForwardRef as ReactComponent };